import { RedirectPaths, RedirectPathsEnum } from '@/common/constants';
import { useAppSelector } from '@/hooks/store';
import { selectCurrentAccount } from '@/store/features/account/current-account.slice';
import { AppButton } from '@/ui/buttons';
import { FlexContainer } from '@/ui/styled-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const StyledContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: var(--purple-dark);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 0 50px;
`;

const StyledWatermark = styled.div`
  position: absolute;
  top: calc(var(--default-padding) * -1);
  left: calc(var(--default-padding) * -1);
  width: 100%;
  opacity: 0.08;

  img {
    width: 1150px;
  }
`;

const StyledContent = styled(FlexContainer)`
  text-align: left;
  max-width: 500px;
  z-index: 2;
  position: relative;
`;

const StyledTitle = styled.h1`
  font-size: 28px;
  line-height: 130%;
  color: var(--white-main);
  font-weight: bold;
  margin-bottom: 0;

  @media (orientation: portrait) and (min-width: 768px) {
    font-size: 40px;
    line-height: 44px;
  }
`;

const StyledSubtitle = styled.h2`
  font-size: 28px;
  line-height: 130%;
  color: white;
  font-weight: bold;
  margin-top: 0;

  @media (orientation: portrait) and (min-width: 768px) {
    font-size: 40px;
    line-height: 44px;
  }
`;

const StyledDescription = styled.p`
  line-height: 150%;
  color: white;
  margin-bottom: 0;

  @media (orientation: portrait) and (min-width: 768px) {
    font-size: 25px;
  }
`;

const StyledFooter = styled.div`
  position: absolute;
  bottom: var(--default-padding);
  right: var(--default-padding);
  z-index: 2;

  img {
    max-width: 140px;
  }
`;

const StyledButton = styled(AppButton)`
  margin-top: var(--big-padding);
`;

export const MobileUnsupportedScreen: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const currentAccount = useAppSelector(selectCurrentAccount);

  const handleGoToLearnerDashboard = () => {
    navigate(RedirectPaths[RedirectPathsEnum.LEARNER_DASHBOARD_ACTIVE]());
  };

  return (
    <StyledContainer>
      <StyledWatermark>
        <img src={currentAccount?.platformSettings?.logo} />
      </StyledWatermark>

      <StyledContent direction="column" justify="center" align="flex-start">
        <StyledTitle>{t('dashboard.mobile.unsupported.title')}</StyledTitle>
        <StyledSubtitle>
          {t('dashboard.mobile.unsupported.subtitle')}
        </StyledSubtitle>
        <StyledDescription>
          {t('dashboard.mobile.unsupported.description')}
        </StyledDescription>
        <StyledDescription>
          {t('dashboard.mobile.unsupported.goToLearnerDashboard')}
        </StyledDescription>
        <StyledButton
          label={t('dashboard.mobile.unsupported.goToLearnerDashboard.link')}
          onClick={handleGoToLearnerDashboard}
          size="lg"
        />
      </StyledContent>

      <StyledFooter>
        <img src={currentAccount?.platformSettings?.logo} />
      </StyledFooter>
    </StyledContainer>
  );
};
